import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import './OrganizationSwitcher.css';
import { Divider } from 'antd';
import CH_Text from '../../assets/img/care_hires_text.png';
import Care_Hires from "../../assets/img/Care_Hires.png";
import AlertIcon from '../../assets/img/yellow-warning.png';
import { getUserImages } from '../../services/common.service';
import { getCookie, setCookie } from '../../utils/cookies';
import { getUserDataByUID } from '../../services/auth.service';
import { useNavigate } from 'react-router-dom';
import { getDomain } from "tldts";

interface OrganizationSwitcherProps {
  show: boolean;
  userData: any;
  userCompanies: any;
  expiresInDays?: number;
  isRedirectToMfaSetup?: boolean;
}

const OrganizationSwitcher: React.FC<OrganizationSwitcherProps> = ({
  show,
  userData,
  userCompanies,
  expiresInDays,
  isRedirectToMfaSetup,
}) => {
  const accessToken = getCookie("firebase_token") as string;
  const [greeting, setGreeting] = useState<string>('Good Day');
  const [currentUser, setCurrentUser] = useState<any>(userData);
  const navigate = useNavigate();
  const userGroup = userData?.provider ? 'provider' : 'agency';

  const getDomainUrl = () => {
    return getDomain(window.location.href) || "";
  };

  useEffect(() => {
    const currentHour = new Date().getHours();
    setGreeting(currentHour < 12 ? 'Good Morning' : currentHour < 18 ? 'Good Afternoon' : 'Good Evening');
  }, []);

  useEffect(() => {
    const fetchUserImages = async () => {
      if (userData?.provider?.parentCompany || userData?.agency?.parentCompany) {
        const type = "parent-company";
        const ids = [userData?.provider?.parentCompany?._id || userData?.agency?.parentCompany?._id];
  
        try {
          const res = await getUserImages(type, ids, accessToken);
          if (res.data.length > 0) {
  
            if (userData.userGroup === 'Provider') {
              setCurrentUser({
                ...userData,
                provider: {
                  ...userData.provider,
                  parentCompany: {
                    ...userData.provider.parentCompany,
                    image: res.data[0].image
                  }
                }
              })
            } else {
              setCurrentUser({
                ...userData,
                agency: {
                  ...userData.agency,
                  parentCompany: {
                    ...userData.agency.parentCompany,
                    image: res.data[0].image
                  }
                }
              })
            }
          }
        } catch (error) {
          console.error('Error fetching user images:', error);
        }
      }
    };
  
    fetchUserImages();
  }, [ ]); 

  const handleSelect = async (org: any): Promise<void> => {
    const updatedCompanies = userCompanies.map((company: any) => {
      return {
        ...company,
        isSelected: company === org
      };
    })
    if (org.provider) {
      const providerUserData = await getUserDataByUID(userData.uid, accessToken, undefined, org?.provider?._id);
      localStorage.setItem("ch_user_data", JSON.stringify(providerUserData.data));
      localStorage.setItem("companies", JSON.stringify(updatedCompanies))
      if (expiresInDays) {
        setCookie(
          "ch_user_data",
          JSON.stringify(providerUserData.data),
          expiresInDays,
          getDomainUrl()
        );
        if(isRedirectToMfaSetup) {
          navigate("/dashboard/Security");
        } else{          
          navigate("/dashboard");
        }
      } else {
        window.location.reload();
      }

    } else {
      const agencyUserData = await getUserDataByUID(userData.uid, accessToken, org?.agency?._id, undefined);
      localStorage.setItem("ch_user_data", JSON.stringify(agencyUserData.data));
      localStorage.setItem("companies", JSON.stringify(updatedCompanies))
      if (expiresInDays) {
        setCookie(
          "ch_user_data",
          JSON.stringify(agencyUserData.data),
          expiresInDays,
          getDomainUrl()
        );
        if(isRedirectToMfaSetup) {
          navigate("/dashboard/Security");
        } else{          
          navigate("/dashboard");
        }
      } else {
        window.location.reload();
      }
    }
  }

  return (
    <Modal
      show={show}
      dialogClassName="modal-90w"
      centered
      backdrop="static"
      contentClassName="Organization-modal-content"
    >
      <Modal.Header className="custom-modal-header">
        <div className="header-container">
          <div className="image-container">
            <img src={ CH_Text} width={221} alt="Care Hires" />
          </div>
          <div className="organization-container">
            <img
              src={currentUser.provider?.parentCompany?.image?.imageSmall || currentUser.agency?.parentCompany?.image?.imageSmall ? currentUser.provider?.parentCompany?.image?.imageSmall || currentUser.agency?.parentCompany?.image?.imageSmall :Care_Hires}
              alt="Parent Company"
              className="right-corner-image"
            />
            <span className="organization-name">{currentUser?.provider?.parentCompany?.name || currentUser.agency?.parentCompany?.name}</span>
          </div>
        </div>
      </Modal.Header>
      <Divider style={{ margin: 0 }} />
      <Modal.Body className="modal-body-with-footer">
      <h1>{greeting}, {userData?.fullName}</h1>
      <p className="sub-heading">The subsidiaries listed below have been added to your parent company by the admin. Please select the {userGroup} you wish to view.</p>
      <div className="organization-list">
      {userCompanies.map((org: any) => (
            <div
              key={org.id}
              className={`organization-card ${org.isSelected ? 'selected' : ''}`}
              onClick={() => handleSelect(org)}
            >
              <div className="organization-card-header">
                <img src={org?.image?.imageSmall ? org.image.imageSmall : Care_Hires} />
                {org.isDefault && <span className="default-tag">Default</span>}
              </div>
              <div className="organization-card-body">
                {org.isSelected && (
                  <p className="logged-in-text">Currently logged in to</p>
                )}
                <h6>{org.name}</h6>
                {userGroup === 'provider'  && (<p style={{color: 'black'}}>You have access to {org.careHomes.length} <strong>{`Site${org.careHomes.length > 1 ? 's' : ''}`}</strong></p>)}
                {userGroup === 'agency' && (<p style={{color: 'black'}}>You have access to {org.locations.length} <strong>{`Site${org.locations.length > 1 ? 's' : ''}`}</strong></p>)}
              </div>
            </div>
          ))}
      </div>
      </Modal.Body>
      <div className="custom-modal-footer">
        <div className="banner-message">
          <img src={AlertIcon} className="alert-icon" alt="Alert Icon" />
          <p>To make changes or add to your parent company, get in touch with the Care Hires Team.</p>
          <a href="#" className="contact-link">Get in touch with the team</a>
        </div>
      </div>
    </Modal>
  );
};

export default OrganizationSwitcher;
